module.exports = __webpack_public_path__ + "img/icon-chevron.f9566c7d.svg";